import { Tool } from '@procureai/agents';
import { ToolLoading, ToolResult } from '@procureai/uix/ai';
import { useTranslation } from 'react-i18next';

import { SvbrgWebSearchInput, SvbrgWebSearchOutput } from '@/generated/gql/graphql';
import { I18nNamespace } from '@/legacy/common/types';

import { ToolResultComponent } from '.';

export const AskWebSearchTool: ToolResultComponent<Tool.askWebSearch, SvbrgWebSearchInput, SvbrgWebSearchOutput> = ({
  tool,
  toolName,
}) => {
  const { t } = useTranslation(I18nNamespace.intake, { keyPrefix: `Chat.tools.${toolName}` });

  switch (tool.state) {
    case 'input-available':
    case 'input-streaming':
      return (
        <ToolLoading
          label={t(`call`, {
            intent: 'identify suppliers',
          })}
        />
      );

    case 'output-available': {
      const sources = tool.output.sources || [];
      const queries = tool.output.groundingMetadata?.searchQueries || [];

      return (
        <ToolResult
          label={t(`result`, {
            count: sources.length,
            description: queries.join(', '),
          })}
          defaultOpen={false}
        />
      );
    }
  }
};
